import {PostComments} from "../GetComments";
import {IVkMethod} from "../../IVkMethod";
import {WallGetCommentsParams} from "../../methods/WallGetCommentsParams";
import * as methods from "../../methods/VkMethods";
import _chunk from "lodash/chunk";
import {ProcessMethodsParams} from "../../types";
import {Comment} from "../../objects/Comment";
import SendMethodsDefault from "../../helpers/SendMethodsDefault";
import {WithDefaultActions} from "../../../store/parsers/types";

export interface GetRemainingChildrenCommentsParams extends WithDefaultActions {
    comments: PostComments[],
    preview_length: number,
    access_token: string,
}

const GetRemainingChildrenComments = function* (params: GetRemainingChildrenCommentsParams) {
    const executes: Array<IVkMethod> = prepare(params.comments, params.preview_length);
    if (executes.length === 0) {
        return [];
    }
    const executes_result: PostComments[] = yield send({
        methods: executes,
        access_token: params.access_token,
        progress_action: params.progress_action,
        add_api_errors_action: params.add_api_errors_action
    });
    return executes_result;
};

function prepare(all_comments: PostComments[], preview_length: number): IVkMethod[] {
    const methods_per_execute: number = 20;
    const count: number = 100;

    const requests: string[] = [];
    all_comments.forEach((item: PostComments) => {
        item.comments.forEach((comment: Comment) => {
            if (comment.thread && comment.thread.count > 10) {
                for (let offset: number = 10; offset < comment.thread.count; offset += count) {
                    const params: WallGetCommentsParams = {
                        owner_id: item.owner_id,
                        post_id: item.post_id,
                        comment_id: comment.id,
                        offset: offset,
                        count: count,
                        need_likes: 1,
                        preview_length: preview_length,
                    };
                    const method: IVkMethod = methods.wallGetComments(params);
                    requests.push(`{owner_id: ${item.owner_id}, post_id: ${item.post_id}, result: API.${method.method_name}(${JSON.stringify(method.params)})}`);
                }
            }
        });
    });

    if (requests.length === 0) {
        return [];
    }

    const requests_chunks: string[][] = _chunk(requests, methods_per_execute);
    return requests_chunks.map((chunk: string[]) => {
        const code:string = `return [${chunk.join(",")}];`;
        return methods.execute({code: code});
    });
}

const send = function* (params: ProcessMethodsParams): Generator<any, PostComments[], any> {
    interface TResponse {
        owner_id: number,
        post_id: number,
        result: {
            count: number,
            items: Comment[],
        }|false
    }

    const map: Map<string, PostComments> = new Map<string, PostComments>();

    const handler = (response: TResponse[]) => {
        response.forEach((response_item: TResponse) => {
            if (!response_item.result) {
                return;
            }
            let comments: Comment[] = [];
            response_item.result.items.forEach((comment: Comment) => {
                if (comment.thread && comment.thread.count > 0) {
                    comments = comments.concat(comment.thread.items);
                    comment.thread.items = [];
                }
                comments.push(comment);
            });
            const unique_id: string = `${response_item.owner_id}_${response_item.post_id}`;
            let post_comments: PostComments = map.get(unique_id) ||
                {
                    owner_id: response_item.owner_id,
                    post_id: response_item.post_id,
                    comments: [],
                };
            post_comments.comments = post_comments.comments.concat(comments);
            map.set(unique_id, post_comments);
        });
    };

    yield SendMethodsDefault<TResponse[]>({
        methods_params: params,
        response_handler: handler,
        progress_text: 'Получаем комментарии',
        chunk_size: 6,
    });
    return Array.from(map.values());
};

export default GetRemainingChildrenComments;
